import type { Pole, PoleMotion } from "../../shared/gl";

/**
 * The green field behind Proof: the prototype's `HALO` (config.js). The name
 * is the prototype's; the field began as the Expertise halo and moved here.
 */
export const HALO = {
    dprMax: 1,
    scale: 0.74,
    /** Distance from the canvas's left edge in p-space, desktop. */
    fromLeft: 0.441,
    /** Offset from the centre on the stacked widths (≤1023). */
    stackedOffsetX: -0.45,
    offsetY: 0.34,

    colorFalloff: 1.95,
    falloff: 1.05,
    edgeGain: 1.6,
    edgeShape: 2.1,

    shapeWarpAmp: 0.07,
    shapeWarpFreq: 0.52,
    shapeWarpSpeed: 0.026,
    colorWarpAmp: 0.22,
    colorWarpFreq: 0.48,
    colorWarpSpeed: 0.03,

    blurPx: 108,
    blurIterations: 3,
    blurBreath: 0.26,
    blurBreathPeriod: 70,

    // The cursor shifts the tone only: no follow, lean or stretch
    curRadius: 0.7,
    curWarp: 0,
    curSat: 0.22,
    curHue: -7.0,
    curSpread: 0.1,
    /** Follow lag, per 60Hz frame. */
    ease: 0.055,
    /** Reveal / settle speed, per 60Hz frame. */
    fade: 0.03,
};

export const HALO_MOTION: PoleMotion = {
    colorSpread: 1.05,
    shapeDrift: 0.035,
    shapePeriodMul: 2.2,
    shapeRound: 0.85,
    orbitAmp: 0.14,
    orbitPeriod: 62,
    radiusBreath: 0.16,
    radiusBreathPeriod: 54,
    brightBreath: 0.1,
    satBreath: 0.14,
    breathPeriod: 48,
    paletteWash: 0,
};

export const HALO_POLES: readonly Pole[] = [
    { x: 0.02, y: -0.02, r: 0.3, color: "#b1fbec" },
    { x: -0.26, y: -0.1, r: 0.31, color: "#289581" },
    { x: 0.22, y: -0.14, r: 0.3, color: "#008f77" },
    { x: -0.08, y: 0.18, r: 0.31, color: "#289581" },
    { x: 0.28, y: 0.14, r: 0.3, color: "#4ac4b0" },
    { x: -0.22, y: 0.1, r: 0.29, color: "#197062" },
];
